export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_2560000-00dddf94fc4460739a5046a6f63eb9b3.avif";